import { AnalyticsQuery } from '@/analytics/AnalyticsQuery';
import { defineStore } from 'pinia';
import { useFiltersStore } from '@/store/FiltersStore';
import { useDateRangeStore } from '@/store/DaterangeStore';
import { useAnalyticsStore } from '@/store/AnalyticsStore';
import { AUDIT_SUBSYSTEMS } from '@enegelai/core';

export const useAuditFiltersStore = defineStore('auditFiltersStore', () => {
  const analyticsStore = useAnalyticsStore();
  const base = useFiltersStore();
  const dateRangeStore = useDateRangeStore();

  const kbAuditFilters = [
    { type: 'terms', title: 'Document ID', field: 'object_id' },
    { type: 'terms', title: 'User', field: 'user.name' },
    { type: 'term', title: 'KB ID', field: 'metadata.kb_id', hidden: true },
    { type: 'terms', title: 'subsystem', field: 'subsystem', hidden: true },
  ];

  base.initFilters('kbaudit', kbAuditFilters);
  base.setFilterValue('subsystem', AUDIT_SUBSYSTEMS.KB_AUDIT);

  async function getFieldTerms(fieldName) {
    const filters = base.toElasticFilters();
    const q = AnalyticsQuery.getFieldTermsQuery(fieldName, dateRangeStore.timeInterval, filters, 100, 'audit');
    await analyticsStore.executeAnalyticsQuery(q);
    let terms = [];
    if (q.success) {
      terms = (q?.result?.aggregations?.terms?.buckets || []).map((x) => x.key);
    }
    return terms;
  }

  // Attach getFieldTerms directly to the base store so that the reactive context is preserved.
  base.getFieldTerms = getFieldTerms;

  return base;
});
